module.exports = __webpack_public_path__ + "img/gofo.53566288.svg";